import { FC, useEffect, useState } from 'react';
import { Select, Spin } from 'antd';
import { fetchProducts } from '../../api/product';
import { Product } from '../../api/product';

interface ProductSelectorProps {
  value?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
}

const ProductSelector: FC<ProductSelectorProps> = ({ value, onChange, disabled }) => {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadProducts = async () => {
      setLoading(true);
      try {
        const data = await fetchProducts();
        setProducts(data);
      } catch (error) {
        console.error('获取产品列表失败', error);
      } finally {
        setLoading(false);
      }
    };
    loadProducts();
  }, []);

  return (
    <Select
      placeholder="请选择产品"
      value={value}
      onChange={onChange}
      disabled={disabled || loading}
      showSearch
      filterOption={(input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
      }
      options={products.map(product => ({
        value: product.marketProductCode,
        label: `${product.name} (${product.marketProductCode})`
      }))}
      notFoundContent={loading ? <Spin size="small" /> : null}
      style={{ width: '100%' }}
    />
  );
};

export default ProductSelector; 